import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// ****** Services Methods ****** //
import { toast } from 'react-toastify';
import {
  createCity,
  deleteCity,
  getAllCitiesFullService,
  getCities,
  getCity,
  searchCity,
  updateCity,
} from '../../../services/CityServices/CityServices';

export const initialState = {
  loading: false,
  cities: [],
  
  searchCities: null,
  city: {},
  isSearching: false,
};
export const getAllCities = createAsyncThunk('cities/getAllCities', async (page) => {
  try {
    const { data } = await getCities(page);
    return data;
  } catch (ex) {
    console.log(ex);
  }
});
export const getSearchCity = createAsyncThunk('cities/getSearchCity', async (name) => {
  try {
    const { data } = await searchCity(name);
    return data;
  } catch (ex) {
    console.log(ex);
  }
});
export const getCityById = createAsyncThunk('cities/getCityById', async (city_id) => {
  try {
    const { data } = await getCity(city_id);
    return data;
  } catch (ex) {
    console.log(ex);
  }
});

export const addNewCity = createAsyncThunk('cities/addNewCity', async (initialData) => {
  try {
    const { status } = await createCity(initialData);
    if (status >= 200) {
      toast.success('شهر با موفقیت اضافه شده');
      window.location.reload();
    }
  } catch (ex) {
    console.log(ex);
  }
});

export const updateCityById = createAsyncThunk(
  'cities/updateCityById',
  async ({ city_id, initialData }) => {
    try {
      const { status } = await updateCity(city_id, initialData);
      if (status >= 200) {
        toast.success('شهر با موفقیت ویرایش شده');
      }
    } catch (ex) {
      console.log(ex);
    }
  },
);

export const deleteCityById = createAsyncThunk('cities/deleteCityById', async (city_id) => {
  try {
    const { status } = await deleteCity(city_id);
  } catch (ex) {
    console.log(ex);
  }
});
export const getAllCitiesFull = createAsyncThunk(
  'cities/getAllCitiesFull',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await getAllCitiesFullService();
      return data;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const citiesSlice = createSlice({
  name: 'cities',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getAllCities.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllCities.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.cities = payload;
        state.isSearching = false;
        state.searchCities = null;
      })
      .addCase(getCityById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCityById.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.city = payload;
      })
      .addCase(addNewCity.pending, (state) => {
        state.loading = true;
      })
      .addCase(addNewCity.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(getSearchCity.pending, (state) => {
        state.loading = true;
        state.isSearching = true;
      })
      .addCase(getSearchCity.fulfilled, (state, action) => {
        state.loading = false;
        state.searchCities = action.payload;
      })

      .addCase(getAllCitiesFull.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getAllCitiesFull.fulfilled, (state, action) => {
        state.loading = false;
        state.citiesAll = action.payload;
      })

      .addCase(getAllCitiesFull.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default citiesSlice.reducer;
